var debug = 1;

var parseCustomRegExp = /-/g;
Date.parseCustom = function(str) {
  return Date.parse(str.replace(parseCustomRegExp, "/"));
};

window.app.service("timesheetMiddleware", [
  "$rootScope",
  function($rootScope) {
    var today;

    weekFormatter.TRANSFORM_ID = $rootScope.GIT_VERSION;

    return weekFormatter;

    function weekFormatter(timesheet) {
      if (!timesheet) {
        return timesheet;
      }
      timesheet.$formatted = {};
      timesheet.$summary = {
        "1000": 0,
        "1001": 0,
        default: 0
      };

      var end = moment.utc(timesheet.endDate, "YYYY-MM-DD");
      var start = moment.utc(timesheet.startDate, "YYYY-MM-DD");

      timesheet.$formatted.month = end.format("MMM");
      timesheet.$formatted.longMonth = end.format("MMMM");
      timesheet.$formatted.week =
        "Week of " + start.format("MMMM D") + " - " + end.format("D");

      var monthStart = start.format("MMM");
      if (monthStart != timesheet.$formatted.month) {
        timesheet.$formatted.range =
          start.format("MMM D") + " - " + end.format("MMM D");
        timesheet.$formatted.longRange =
          start.format("D MMM") + " - " + end.format("D MMMM");
      } else {
        timesheet.$formatted.range =
          start.format("MMM D") + " - " + end.format("MMM D");
        timesheet.$formatted.longRange =
          start.format("D") + " - " + end.format("D MMMM");
      }

      var next = end.clone();
      next.add(1, "day");
      if (!today) {
        today = moment();
      }
      if (next.isAfter(today) && start.isBefore(today)) {
        timesheet.$formatted.currentWeek = true;
      }

      timesheet.$projects = {};
      timesheet.hours =
        "hours" in timesheet
          ? parseInt(timesheet.hours)
          : parseInt(timesheet.totalHours);

      if (timesheet.timesheetDays) {
        timesheet.hours = 0;
        for (var dayId in timesheet.timesheetDays) {
          dayFormatter(timesheet, timesheet.timesheetDays[dayId]);
        }
      }

      debug > 1 && timesheet.timesheetDays && console.debug(timesheet);
      timesheet.$transformed = weekFormatter.TRANSFORM_ID;

      if (timesheet.statusCode == -10) {
        timesheet.statusCode = 10;
      }

      /* for (var projectId in timesheet.$projects) {
            var projectTotal = timesheet.$projects[projectId];
            for (var taskId in projectTotal.tasksMap) {
                var taskTotal = projectTotal.tasksMap[taskId];
                console.debug(taskTotal.description, taskTotal.hours);
            }
        } */

      return timesheet;
    }

    function dayFormatter(timesheet, day) {
      if (!day) {
        return;
      }

      // if (!day.$formatted) {
      day.$formatted = {};

      var date = moment.utc(day.date, "YYYY-MM-DD");
      day.$formatted.full = date.format("dddd, MMMM D");
      day.$formatted.short = date.format("MMM");
      day.$formatted.day = date.format("dddd");
      day.$formatted.month = date.format("MMM");
      day.$formatted.dayDate = date.format("D");
      day.$formatted.date = date.format("MMMM D");

      day.entryMap = day.entryMap || {};
      day.hours = 0;
      for (var projectId in day.entryMap) {
        var entry = day.entryMap[projectId];
        entry.tasksMap = entry.tasksMap || {};

        var projectTotal = timesheet.$projects[projectId];
        if (!projectTotal) {
          projectTotal = timesheet.$projects[projectId] = angular.copy(entry);
          projectTotal.tasksMap = {};
          projectTotal.hours = 0;
        }

        entry.hours = 0;

        var sorted = Object.keys(entry.tasksMap)
          .sort(function(a, b) {
            if (a.order > b.order) {
              return 1;
            } else if (a.order < b.order) {
              return -1;
            }
            return a.toUpperCase().localeCompare(b.toUpperCase());
          })
          .map(function(key) {
            return entry.tasksMap[key];
          });

        entry.tasksMap = {};
        sorted.forEach(function(task) {
          // console.warn(task);
          entry.tasksMap[task.id] = task;
        });
        for (var taskId in entry.tasksMap) {
          var task = entry.tasksMap[taskId];
          var hours = task.hours || 0;

          var code =
            task.code === "1000" || task.code === "1001"
              ? task.code
              : "default";
          timesheet.$summary[code] += hours;
          // TODO:random
          // task.hours = Math.round(Math.random() * 0.52) ? Math.round(Math.random() * 4.67) : 0;
          entry.hours += hours;

          var taskTotal = projectTotal.tasksMap[taskId];
          if (!taskTotal) {
            projectTotal.tasksMap[taskId] = taskTotal = angular.copy(task);
          } else {
            taskTotal.hours += hours;
          }
          projectTotal.hours += hours;
        }
        day.hours += entry.hours;
      }

      timesheet.hours += day.hours;
    }
  }
]);



// WEBPACK FOOTER //
// ./src/services/apiMiddleware.js